import { __ } from "@libs/utilities"
import { Dialog, Button, ButtonGroup } from "@blueprintjs/core"
import React, { useEffect, useState } from "react" 
import { FaBrandsIcon, FaRegularIcon, FaSolidIcon, FaIcons } from "src/libs/interfaces/layouts"

// https://fontawesome.com/v5/cheatsheet/free
// var names = new Set();
// var icons = document.getElementsByClassName('icon');
// for (const icon of icons) {
//   const name = icon.getElementsByClassName('select-all')[0].classList[2] + " fa-" + icon.getElementsByTagName('dd')[0].innerText;
//   names.add(name);
// }
// console.log(JSON.stringify(Array.from(names)));


const FontAwesome = (props: any) => {
    const [value, setValue] = useState(props.value)
    const [groupID, setGroupID] = useState( FaIcons )
    const [filter, setFilter] = useState("")
    useEffect(() => {
        setValue(props.value)
    }, [props.value])
    const [isOpen, setOpen] = useState(false)
    const setIcon = (val: string) => {
        setValue(val)
        onOpen()
        if (props.onChange)
            props.onChange(val)
    }
    const onOpen = () => {
        setOpen(!isOpen)
    }
    const signs = groupID
        .filter(sign => sign.indexOf(filter) > -1)
            .map((sign, i) => {
                const _title = sign.substring(sign.indexOf("fa-") + 3)
                return <div 
                        key={i} 
                        className=" pe-font-awesome "
                        data-targ={sign}
                        onClick={() => setIcon( sign )}
                    >
                        <i className={sign + " fa-2x " + (sign === value ? " text-danger " : "")} />
                        <span className="small mt-2 text-center">
                            { _title }  
                        </span>
                    </div>
            })
    const arr = typeof value == "string" ? value.split(" ") : []
    const ar_val = arr[1] ? arr[1].toString() : "";
    const vl = ar_val.substring(ar_val.indexOf("-") + 1)
    return <div className="d-flex flex-wrap flex-grow-100">
        <Button
            onClick={onOpen}
            className="d-flex flex-grow-100"
            variant={"minimal"}
            icon={<span className={value + " fa-3x d-flex p-2 mb-0 mr-0 pointer text-danger "} />}
        >
            {vl}
        </Button>
        <Dialog
            isOpen={isOpen}
            onClose={onOpen}
            //title={__("Select Icon")}
            className="layout-outer-container  "
        >
            <div style={{height: "calc(100% - 40px)"}}>
                <div className="row h-100">
                    <div className="col-md-2 py-5 d-flex flex-column">
                        <div className="pt-3">
                            <ButtonGroup fill vertical>
                                <Button variant={groupID !== FaIcons ? "minimal": "solid" } onClick={() => setGroupID( FaIcons )}>
                                    {__("All icons")}
                                </Button>
                                <Button variant={groupID !== FaRegularIcon ? "minimal": "solid" }  onClick={() => setGroupID(FaRegularIcon)}>
                                    {__("Font Awesome Regular")}
                                </Button>
                                <Button variant={groupID !== FaSolidIcon ? "minimal": "solid" } onClick={() => setGroupID(FaSolidIcon)}>
                                    {__("Font Awesome Solid")}
                                </Button>
                                <Button variant={groupID !== FaBrandsIcon ? "minimal": "solid" } onClick={() => setGroupID(FaBrandsIcon)}>
                                    {__("Font Awesome Brands")}
                                </Button>
                            </ButtonGroup>
                        </div>
                        <div className="h-100">

                        </div>
                    </div>
                    <div className="col-md-10 d-flex flex-column h-100">
                        <div className="w-100 p-3">
                            <input 
                                className="input dark form-control" 
                                placeholder="search" 
                                onChange={evt => setFilter( evt.currentTarget.value )}
                            />
                        </div>
                        <div className="d-flex flex-wrap  overflow-y-auto flex-grow-100 " style={{ overflowY: "auto" }}>
                            { signs }
                            <div className="mt-auto w-100"></div>
                        </div>
                    </div>
                </div>
            </div>           
        </Dialog>
    </div>
}
export default FontAwesome